export const SET_TOKEN = 'SET_TOKEN'


// WEBPACK FOOTER //
// ./src/store/mutations-types.js